import React, { useState } from 'react';
//@ts-ignore
import * as styles from './numberedpanel.module.css';
import { graphql } from 'gatsby';
import Background from './asset/rightarrow.svg';
import RichText from '../Global/RichText';
import Modal from '../Global/LazyModal';

import ReactPlayer from '../Global/LazyReactPlayer';

import {
    KontentStringValue,
    KontentMedia,
    KontentRichText,
} from '../../../types/KontentProps';
import {
    getMediaData,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    getDisplayDimensions,
} from '../Global/DataUtils/index';
import LazyImage from '../Global/LazyImage';

type Panel = {
    copy: KontentRichText;
    media_file: KontentMedia;
    list_value_to_display: KontentStringValue;
    title_to_display: KontentStringValue;
    youtube_url_video: {
        value: KontentStringValue;
    };
};

interface KontentPanel {
    value: {
        elements: Panel;
    }[];
}
interface Props {
    kontentItemId?: string;
    panels: KontentPanel;
}

const VideoPlayer: React.FC<Props> = ({ obj }) => {
    const [isActive, setActive] = useState(true);
    const [toopenModal, setOpenModal] = useState(false);

    const customStylesDesktop = {
        content: {
            padding: '0',
        },
    };

    const openModal = () => {
        setOpenModal(true);
        setActive(false);
    };
    const closeModal = () => {
        setOpenModal(false);
        setActive(true);
    };
    return (
        <>
            <div className={`${styles.button} `}>
                <button
                    onClick={openModal}
                    style={{
                        display: isActive ? 'block' : 'none',
                        background: `url(${Background})`,
                        backgroundSize: 'cover',
                    }}
                    className={styles.playButton}
                    aria-label="Play video"
                >
                    {' '}
                </button>
            </div>
            <ReactPlayer
                className={`${styles.reactplayer} ${obj.rowReverse}`}
                url={obj.src}
                width="100%"
                height="100%"
            />

            <Modal
                contentLabel="Media"
                isOpen={toopenModal}
                style={customStylesDesktop}
                onRequestClose={closeModal}
            >
                <ReactPlayer
                    className={`${styles.reactplayerModal}  `}
                    url={obj.src}
                    width="100%"
                    height="100%"
                    controls
                    playing={true}
                />
            </Modal>
        </>
    );
};

const NumberedPanel: React.FC<Props> = ({ panels, kontentItemId }) => {
    const renderMediaView = (
        media_file: KontentMedia,
        rowReverse: Boolean,
        index: number
    ) => {
        const media = getMediaData(media_file);
        const mediaType = media == null ? 'Video' : 'Image';
        const src = media?.url
            ? media.url
            : media_file?.value?.[0]?.elements?.youtube_url?.value;

        switch (mediaType) {
            case 'Video': {
                let obj = {
                    src: src,
                    rowReverse: rowReverse,
                };
                return (
                    <div className={styles.videoWrap}>
                        <VideoPlayer obj={obj} />
                    </div>
                );
            }
            case 'Image': {
                return (
                    <div
                        className={styles.image}
                        data-kontent-element-codename="media_file"
                    >
                        <LazyImage
                            {...getDisplayDimensions(
                                media?.width,
                                media?.height,
                                600
                            )}
                            src={optimizeKontentImageUrl(src, {
                                w: 600,
                                fm: 'webp',
                                q: 80,
                            })}
                            srcSet={buildKontentSrcSet(src, 600, {
                                fm: 'webp' as const,
                                q: 80,
                            })}
                            sizes="(max-width: 768px) 100vw, 33vw"
                            alt=""
                        />
                    </div>
                );
            }
            default: {
                return <h3>Error in renderMediaView - no switchcase match</h3>;
            }
        }
    };

    const renderMainCard = (value: { elements: Panel }, index: number) => {
        //bcz i want the to chek even odd value from starting with 1,but index start with 0 so ++ -> we can remove it;
        index++;

        //for left and right div-only desktopview
        let rowReverse = index % 2 == 0 ? true : false;
        const { media_file } = value?.elements;
        const url =
            value?.elements?.copy?.modular_content?.[0].elements
                ?.third_party_url?.value;
        const title = value?.elements?.title_to_display?.value;
        const copy = value?.elements?.copy;
        const listValue = value?.elements?.list_value_to_display?.value;
        const CheckListValue = parseInt(listValue);
        return (
            <>
                <div
                    className={`${styles.card} ${styles.desktop}`}
                    style={rowReverse ? { flexDirection: 'row-reverse' } : null}
                    key={index}
                >
                    <div
                        className={styles.mediaWrapper}
                        style={rowReverse ? { right: '7%' } : { left: '7%' }}
                    >
                        {renderMediaView(media_file, rowReverse, index)}
                    </div>

                    <div className={styles.child}>
                        {' '}
                        <div className={styles.title}>
                            <div
                                className={styles.numberCircle}
                                style={{
                                    fontSize:
                                        CheckListValue > 99 ? '19px' : null,
                                }}
                            >
                                <div
                                    style={{
                                        marginBlockStart:
                                            CheckListValue > 99 ? '4px' : null,
                                    }}
                                    data-kontent-element-codename="list_value_to_display"
                                >
                                    {listValue}
                                </div>
                            </div>
                            <h5 data-kontent-element-codename="title_to_display">
                                {title}
                            </h5>
                        </div>
                        <p className={styles.paragraph}>
                            <section>
                                {RichText(
                                    copy,
                                    false,
                                    undefined,
                                    undefined,
                                    'copy'
                                )}
                            </section>
                            <div className={styles.link}>
                                <a href={url}>{url}</a>
                            </div>
                        </p>
                    </div>
                </div>
                <div className={styles.mobile}>
                    <div className={`${styles.card}`}>
                        <div className={styles.mediaWrapper}>
                            {renderMediaView(media_file, rowReverse, index)}
                        </div>
                        <div className={styles.child}>
                            <div className={styles.title}>
                                <div
                                    className={styles.numberCircle}
                                    data-kontent-element-codename="list_value_to_display"
                                >
                                    {listValue}
                                </div>
                                <h5 data-kontent-element-codename="title_to_display">
                                    {title}
                                </h5>
                            </div>
                            <p className={styles.paragraph}>
                                <section>
                                    {RichText(
                                        copy,
                                        false,
                                        undefined,
                                        undefined,
                                        'copy'
                                    )}
                                </section>

                                <div className={styles.link}>
                                    <a href={url}>{url}</a>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <div data-kontent-item-id={kontentItemId}>
            {panels.value.map((value: { elements: Panel }, index: number) => {
                return renderMainCard(value, index);
            })}
        </div>
    );
};

export default NumberedPanel;

export const query = graphql`
    fragment NumberedPanel on kontent_item_component___numbered_panels {
        elements {
            panels {
                value {
                    ... on kontent_item_content_item___number_panel {
                        id
                        elements {
                            copy {
                                value
                            }
                            list_value_to_display {
                                value
                            }
                            media_file {
                                value {
                                    ... on kontent_item_media___image {
                                        id
                                        elements {
                                            file {
                                                value {
                                                    url
                                                    width
                                                    height
                                                }
                                            }
                                        }
                                    }
                                    ... on kontent_item_media___general_video {
                                        id
                                        elements {
                                            youtube_url {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            title_to_display {
                                value
                            }
                        }
                    }
                }
            }
        }
    }
`;
